
import React from 'react';

import { Svg2Step3} from '../../../data/SVGs';
import useWindowSize from '../../../hooks/useWindowSize';
import PreferenceGeneralise from '../Profile/PreferenceGeneralise';
import { typeTraitementEnum } from './DonneesPersonnelsExpert';
import DrawSideBar from './SideBar';
import SideBarMobile from './SideBarMobile';

const ExpertStep3 = () => {
    const {device}=useWindowSize();

    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch'}}>
                {/*<div style={{display:'flex',justifyContent:'flex-start',flexDirection:'column',gap:'24px'}}>*/}
                {device=='desktop' &&
                    <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Préférence'}
                        etapSuivante='Société'
                        number='3'
                    />
                }
                {/*<SvgStep3 />*/}
                {/*</div>*/}
                <div style={{display:'flex',width:device=='desktop'?'80%':'100%',justifyContent:'center',paddingTop:device=='desktop'? '64px':'16px'}}>
                    <PreferenceGeneralise typeTraitement={typeTraitementEnum.EXPERT_COMPLETE_PROFILE}/>
                </div>
                {device=='desktop' &&
                <div style={{display:'flex',justifyContent:'flex-start',alignItems: 'flex-start'}}>
                    <Svg2Step3 />
                </div>
                }
            </div>
        </>
    );
};

export default ExpertStep3;

{/*<motion.div
            className="col-md-6 offset-md-3 StepDiv"
            initial={{ x: '-100vw' }}
            animate={{ x: 0 }}
            transition={{ stiffness: 150 }}
            style={{
                width: '100%',
                // marginLeft: "0 % !important",
            }}
        >*/}
{/* </motion.div>*/}